/* July 2026: require an explicit size choice before add-to-cart (product page + quick-add popup).
   Injects a "choose size" placeholder into every size dropdown (no default size) and blocks
   the add-to-cart submit until a real size is picked. */
(function () {
  'use strict';
  var COLOR_NAMES = ['color', 'colour', 'צבע', 'color_description'];
  var PLACEHOLDER_TEXT = 'בחירת מידה';
  var ERROR_TEXT = 'יש לבחור מידה';
  /* Not every dropdown this guard protects is a size. A gift card's option is
     an amount, and "בחירת מידה" on it reads like a bug. When the option is
     named something else, the option's own name is the placeholder. */
  var SIZE_OPTION_NAMES = ['size', 'sizes', 'מידה', 'מידות'];
  function placeholderFor(optionName) {
    var name = (optionName || '').trim();
    if (!name || SIZE_OPTION_NAMES.indexOf(name.toLowerCase()) >= 0) return PLACEHOLDER_TEXT;
    return name;
  }
  function errorFor(optionName) {
    var name = (optionName || '').trim();
    if (!name || SIZE_OPTION_NAMES.indexOf(name.toLowerCase()) >= 0) return ERROR_TEXT;
    return 'יש לבחור ' + name;
  }

  var chosenByForm = {};
  var lastUserChangeAt = 0;

  function keyFor(sel) {
    var vs = sel.closest('variant-selects, variant-radios');
    var url = (vs && vs.dataset && vs.dataset.url) || '';
    return url + '|' + (sel.getAttribute('form') || ((sel.closest('form') || {}).id) || 'default');
  }

  document.addEventListener('change', function (e) {
    var s = e.target;
    if (s && s.matches && s.matches('select.product_variant_select') && s.value !== '') {
      chosenByForm[keyFor(s)] = s.value;
      lastUserChangeAt = Date.now();
    }
  }, true);

  function optionNameOf(sel) {
    var m = (sel.getAttribute('name') || '').match(/^options\[(.+)\]$/);
    return m ? m[1] : '';
  }
  function isSizeSelect(sel) {
    var name = sel.getAttribute('name') || '';
    var m = name.match(/^options\[(.+)\]$/);
    if (!m) return false;
    return COLOR_NAMES.indexOf(m[1].toLowerCase()) === -1;
  }

  function clearError(sel) {
    var wrap = sel.closest('.select') || sel;
    wrap.classList.remove('select--size-error');
    var p = wrap.parentElement;
    var msg = p && p.querySelector('.size-required-msg');
    if (msg) msg.remove();
  }

  function showError(sel) {
    var wrap = sel.closest('.select') || sel;
    wrap.classList.add('select--size-error');
    var p = wrap.parentElement;
    if (!(p && p.querySelector('.size-required-msg'))) {
      var msg = document.createElement('div');
      msg.className = 'size-required-msg';
      msg.textContent = errorFor(optionNameOf(sel));
      wrap.insertAdjacentElement('afterend', msg);
    }
    try { sel.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) {}
  }

  function ensurePlaceholder(sel) {
    if (sel.dataset.sizeGuard) return;
    sel.dataset.sizeGuard = '1';
    if (!(sel.firstElementChild && sel.firstElementChild.hasAttribute('data-size-placeholder'))) {
      var ph = document.createElement('option');
      ph.value = '';
      ph.textContent = placeholderFor(optionNameOf(sel));
      ph.setAttribute('data-size-placeholder', '1');
      ph.disabled = true;
      ph.hidden = true;
      sel.insertBefore(ph, sel.firstChild);
    }
    sel.addEventListener('change', function () { clearError(sel); });
    var prior = chosenByForm[keyFor(sel)];
    if (prior && [].some.call(sel.options, function (o) { return o.value === prior; })) {
      sel.value = prior;
      return;
    }
    var keepSelection = /[?&]variant=/.test(window.location.search) && !sel.closest('quick-add-modal');
    // a re-render right after a real user choice carries that choice as the selected option — don't wipe it
    if (Date.now() - lastUserChangeAt < 6000) keepSelection = true;
    if (!keepSelection) sel.value = '';
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var list = scope.querySelectorAll('select.product_variant_select');
    for (var i = 0; i < list.length; i++) {
      if (isSizeSelect(list[i])) ensurePlaceholder(list[i]);
    }
  }

  function sizeSelectsFor(el) {
    var scope = (el.closest && (el.closest('quick-add-modal') || el.closest('sticky-add-to-cart') || el.closest('.product__info-container') || el.closest('section'))) || document;
    var out = [], list, i;
    list = scope.querySelectorAll('select.product_variant_select');
    for (i = 0; i < list.length; i++) if (isSizeSelect(list[i])) out.push(list[i]);
    return out;
  }

  function guard(e, el) {
    var sels = sizeSelectsFor(el);
    for (var i = 0; i < sels.length; i++) {
      if (sels[i].value === '') {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        showError(sels[i]);
        return true;
      }
    }
    return false;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('.product-form__submit');
    if (btn) guard(e, btn);
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.getAttribute && form.getAttribute('data-type') === 'add-to-cart-form') guard(e, form);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if ((n.matches && n.matches('select.product_variant_select')) || (n.querySelector && n.querySelector('select.product_variant_select'))) {
          initAll(n);
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
